import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import EventListResults from 'src/components/event/EventListResults';
import EventListToolbar from 'src/components/event/EventListToolbar';
import { searchEvents } from 'src/utils/helper';
import { useNavigate } from 'react-router';
import _ from 'lodash';
import FirebaseApp, { Collections } from 'src/config/firebase.config';

const EventList = () => {
  const FirebaseDB = FirebaseApp.firestore();
  const [events, setEvents] = useState([]);
  const [fullList, setFullList] = useState([]);
  const [search, setSearch] = useState('');
  const [sortDirectionTitle, setSortDirectionTitle] = useState('asc');
  const [sortDirectionDate, setSortDirectionDate] = useState('asc');
  const navigate = useNavigate();

  const onSort = (row) => {
    if (row === 'StartDate') {
      if (sortDirectionDate === 'asc') {
        setSortDirectionDate('desc');
        setEvents([..._.orderBy(events, 'createdAt', 'desc')]);
      } else {
        setSortDirectionDate('asc');
        setEvents([..._.orderBy(events, 'createdAt', 'asc')]);
      }
      setSortDirectionTitle('asc');
    } else if (row === 'EventTitle') {
      if (sortDirectionTitle === 'asc') {
        setSortDirectionTitle('desc');
        setEvents([..._.orderBy(events, 'title', 'desc')]);
      } else {
        setSortDirectionTitle('asc');
        setEvents([..._.orderBy(events, 'title', 'asc')]);
        setSortDirectionDate('asc');
      }
    }
  };

  const FetchEvents = () => {
    FirebaseDB.collection(Collections.Events).get().then((querySnapshot) => {
      // Loop through the data and store
      // it in array to display
      querySnapshot.forEach((element) => {
        const data = element.data();
        setFullList((arr) => [...arr, { id: element.id, ...data }]);
        setEvents((arr) => [...arr, { id: element.id, ...data }]);
      });
    });
  };

  useEffect(() => {
    FetchEvents();
  }, []);

  useEffect(() => {
    setEvents(searchEvents(fullList, search));
  }, [search]);

  return (
    <>
      <Helmet>
        <title>Events | Lead Generation</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <EventListToolbar onSearch={(text) => {
            setSearch(text);
          }}
          />
          <Box sx={{ pt: 3 }}>
            <EventListResults
              events={events}
              onItemClick={(item) => {
                navigate(`/app/events/${item.id}`, { replace: false, state: item });
              }}
              sortDirectionDate={sortDirectionDate}
              sortDirectionTitle={sortDirectionTitle}
              onSort={onSort}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default EventList;
